import { useCallback, useEffect, useState } from 'react'

export type FontSize = 'small' | 'medium' | 'large'

const STORAGE_KEY = 'radiri-font-size'
const FONT_SIZE_CHANGE_EVENT = 'radiri:font-size-change'

function getInitialFontSize(): FontSize {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved === 'small' || saved === 'medium' || saved === 'large') return saved
  return 'medium'
}

export function useFontSize(): [FontSize, (s: FontSize) => void] {
  const [fontSize, setFontSize] = useState<FontSize>(getInitialFontSize)

  useEffect(() => {
    if (fontSize === 'medium') {
      document.documentElement.removeAttribute('data-font-size')
    } else {
      document.documentElement.setAttribute('data-font-size', fontSize)
    }
    localStorage.setItem(STORAGE_KEY, fontSize)
  }, [fontSize])

  useEffect(() => {
    function handler(e: Event) {
      const incoming = (e as CustomEvent<{ fontSize: string }>).detail.fontSize
      if (incoming === 'small' || incoming === 'medium' || incoming === 'large') {
        setFontSize(incoming)
      }
    }
    window.addEventListener(FONT_SIZE_CHANGE_EVENT, handler)
    return () => window.removeEventListener(FONT_SIZE_CHANGE_EVENT, handler)
  }, [])

  const applyFontSize = useCallback((s: FontSize) => { setFontSize(s) }, [])
  return [fontSize, applyFontSize]
}
